import { Autocomplete, TextField } from '@mui/material';
import React from 'react';

interface OptionsType {
    value: string;
    label: string;
}

export interface MultipleSelectProps {
    options: OptionsType[];
    contactTypes: OptionsType[];
    setContactTypes: React.Dispatch<React.SetStateAction<OptionsType[]>>;
}

const MultipleSelect: React.FC<MultipleSelectProps> = (props) => {
    return (
        <Autocomplete
            multiple
            id="contactTypes"
            options={props.options}
            getOptionLabel={(option) => option.label}
            value={props.contactTypes}
            onChange={(e, value) => {
                if (e) props.setContactTypes(value);
            }}
            style={{ width: '98%', padding: '0.8rem' }}
            renderInput={(params) => <TextField {...params} variant="outlined" label="Contact Types" fullWidth />}
        />
    );
};

export default MultipleSelect;
